import axios from './http'
//基础数据api
import basedata from './modules/basedata.js'

export default {
  ...basedata,
  post(url, params, timeout) {
    if (timeout) {
      return axios.post(url, params, {
        timeout: timeout,
      })
    }
    return axios.post(url, params)
  },
  get(url) {
    return axios.get(url)
  },
  delete(url) {
    return axios.delete(url)
  },
}
